import { useTranslation } from 'libs/i18n'
import { useNavigate } from 'libs/router'
import { routes } from 'config/routes'
import type { Option } from 'shared/components/ContextMenu/types'
import type { CategoryItem } from 'features/categories/types/categories.types'

type UseContextMenuOptionsProps = {
	onEdit: (category: CategoryItem) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({
	onEdit,
	onDelete
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return [
		{
			label: t('Edit'),
			action: (_id: number, category: CategoryItem) => onEdit(category)
		},
		{
			label: t('History'),
			action: (id: number) => navigate(routes.categoryHistory(String(id)))
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
